import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import Link from "next/link";

const EarthDayArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/earth-day`;

  return (
    <MainLayout>
      <NextSeo
        title='19,800 trees planted with Trees for the Future partnership | DAYMADE'
        description='This Earth Day marks 6 months of partnership between DAYMADE and Trees for the Future and more than 19,800 trees planted.'
        openGraph={{
          title: '19,800 trees planted with Trees for the Future partnership | DAYMADE',
          description: 'This Earth Day marks 6 months of partnership between DAYMADE and Trees for the Future and more than 19,800 trees planted.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/19800-trees-planted-with-partnership-daymade-and-trees-for-the-future',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'three smiling children each holding a small tree ready to be planted'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'charity,trees,planting,forest,trees for the future,partnership,offset,carbon,giving back,earth,earth day,farmers,regenerative,climate'
        // }]}
      />
      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText='three smiling children each holding a small tree ready to be planted'
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            <strong>Happy Earth Day</strong>
          </h1>

          <p className='subheading'>
            19,800 trees planted with Trees for the Future partnership
          </p>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>T</span>his Earth Day marks 6 months of partnership between DAYMADE and Trees for the Future and more than 19,800 trees planted.
          </p>

          <p>
            Trees for the Future (TREES) is an international development nonprofit working to train smallholder farmers in regenerative agroforestry and climate-smart agriculture techniques. TREES and DAYMADE are having a direct impact on the planet by contributing to reforestation efforts, eliminating the need for smallholder deforestation, improving carbon capture through trees and soil, and eliminating the need for chemical inputs on farmland.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt='irrigated field with various healthy-looking plants and trees'
            className='singleBlogImage'
          />

          <p>
            “The solution to our climate crisis is in the way we grow our food and treat our land,” says TREES Executive Director John Leary. “With help from vital business partners, we’re reaching some of the most vulnerable people on the planet and giving them the tools to achieve nutritional and economic stability, all while repairing their land and the environment.”
          </p>

          <p>
            DAYMADE is a Plant A Tree Partner of TREES. For every purchase on DAYMADE, Trees for the Future plants 1 tree. DAYMADE wants to give a massive thanks to all its players for contributing to the planet and continuing to plant trees every day!
          </p>

          <p>
            Learn more about this partnership <a href='https://trees.org/sponsor/daymade/' target='_blank' style={{ margin: 0, fontWeight: 'bold' }}>here</a> and {''}
            <Link href='/giving-back' style={{ margin: 0, fontWeight: 'bold' }}>
              
                here
              
            </Link>
            {''}.
          </p>

          <p>
            {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                Enter DAYMADE
              
            </Link>
            {''} now to start planting trees.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt='1 year comparison of farming land - first half shows barren, dry, empty land, whereas 2019 show luscious greenery - planted by Trees for the Future'
            className='singleBlogImage'
          />
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default EarthDayArticle;
